import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import carImg1 from 'images/tmp_fincar_image01.png'
import carImg2 from 'images/tmp_fincar_image02.png'
import carImg3 from 'images/tmp_fincar_image03.png'
import carImg4 from 'images/tmp_fincar_image04.png'

const FincarResult = () => {

	const App = useApp()
	const [showFilter, setShowFilter] = useState(false)
	const [toggleFilter, setToggleFilter] = useState(false)

	const openFilter = () => {
		setShowFilter(true)
	}

	const closeFilter = () => {
		setShowFilter(false)
	}

	const toggle = () => {
		setToggleFilter(!toggleFilter)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: <div className={styles["compare-box"]}>
				<i className="icon_compare_line" />
				<div>비교함 <span>1</span></div>
			</div>,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page pb_100">
			<div className="shadow">
				<div className="padding pt_30">
					<h3 className="flex-align_center">
						검색결과
						<span className="text-blue ml_10">2,352대</span>
					</h3>
				</div>
				<div className="no-scroll pb_40" style={{ overflowX: "auto" }}>
					<ul className={`${styles["tag-scroll"]}`}>
						<li>기아</li>
						<li>국산</li>
						<li>현대 아반떼 AD</li>
						<li>2016년 ~ 2018년</li>
						<li>연료(3)</li>
						<li>옵션</li>
					</ul>
				</div>
			</div>

			<div className="padding pt_30">
				<div className="flex-justify_between align_center">
					<div className="flex-align_center">
						<i className={`checkMark`} />
						<span className="ml_10">판매완료 포함</span>
					</div>
					<div className="flex-align_center">
						<div className="filter-group">
							<div onClick={openFilter}>
								<span>등록일 최신순</span>
								<i className="icon icon_filter ml_5" />
							</div>
						</div>

						{/* icon_filter_group 클릭 시 box 클래스 추가 */}
						<i onClick={toggle} className={`icon icon_filter_group ml_10 ${toggleFilter ? "icon_filter_box" : ""}`} />
					</div>
				</div>

				{/* icon_filter_group일 때 type-group 클래스  /  box일 때 type-box 클래스 */}
				<ul className={`${styles["car-list"]} ${styles["type-box"]} list-bg mt_50`}>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg1} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like} ${styles.on}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare} ${styles.on}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg2} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>

					<li className={styles["sold-out"]}>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>

								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>

								{/* 판매완료인 경우 sold-out 클래스 추가 img-box 안에 div 추가 */}
								<div className={styles["sold-out-txt"]}><span>판매완료</span></div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
				</ul>

				{/* icon_filter_group일 때 type-group 클래스  /  box일 때 type-box 클래스 */}
				<ul className={`${styles["car-list"]} ${styles["type-group"]} mt_50`}>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg1} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like} ${styles.on}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare} ${styles.on}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
								<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg2} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg3} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>

					<li className={styles["sold-out"]}>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg4} alt="" />

								{/* 판매완료인 경우 sold-out 클래스 추가 img-box 안에 div 추가 */}
								<div><span>판매완료</span></div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<div className="padding btn--fixed">
				<Button className="btn btn--big">재검색</Button>
			</div>

			<SelectLayer show={showFilter} closeLayer={closeFilter} />
		</div>
	)
}

const SelectLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="정렬필터" show={show} closeLayer={closeLayer}>
			<ul className="select-list">
				<li className="on">등록일 최신 순</li>
				<li>주행거리 적은 순</li>
				<li>연식 최근 순</li>
				<li>가격 낮은 순</li>
				<li>가격 높은 순</li>
			</ul>
		</LayerBottom>
	)
}

export default FincarResult